module.exports = __webpack_public_path__ + "images/hand-2.png";